/**
 * App Router - Routes between detailed and compact views
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DetailedView } from './pages/DetailedView';
import { CompactView } from './pages/CompactView';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DetailedView />} />
        <Route path="/compact" element={<CompactView />} />
      </Routes>
    </BrowserRouter>
  );
}
